import React, { useEffect } from 'react';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest';
import { getLocale, getMbmOptions, getTimeZone } from '../helpers';
import { BadasGuidedPath } from "@amzn/badasui-components-react";
import input_form_pic from 'src/images/input_form_pic.svg';
import icon_list from 'src/images/icon_list.svg';
import icon_tag from 'src/images/icon_tag.svg';
import icon_trademark from 'src/images/icon_trademark.svg';
import video_thumbnail from 'src/images/video_thumbnail.svg';
import {logger} from "src/logger";
import * as KatalMetrics from "@amzn/katal-metrics";
import initialMetricsPublisher from "src/metrics";

const mbmOptions = getMbmOptions(arbManifest);

const App = () => {
    const initializationMetric = new KatalMetrics.Metric.Initialization().withMonitor();
    const initializationMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForInitialization();

    let locale = getLocale();
    let timeZone = getTimeZone();

    useEffect(() => {
        const element = document.querySelector('badas-guided-path');

        const handleIsLoaded = () => {
            initializationMetric.setSuccess();
            initializationMetricsPublisher.publish(initializationMetric);
        };

        element?.addEventListener('isLoaded', handleIsLoaded as EventListener);

        return () => {
            element?.removeEventListener('isLoaded', handleIsLoaded as EventListener);
        };
    }, []);

    logger.info(`Initializing BADAS Seller Central app with Locale: ${locale} and Time Zone: ${timeZone}`);

    return (
        <MbmProvider {...mbmOptions}>
            <BadasGuidedPath
                locale={locale}
                timezone={timeZone}
                metricsPublisher={initialMetricsPublisher}
                logger={logger}
                inputImageSrc={input_form_pic}
                homeImageSrcs={{
                    list: icon_list,
                    tag: icon_tag,
                    trademark: icon_trademark,
                    videoThumbnail: video_thumbnail
                }}
                translationsCdn={"d3rv6bcpnb6t4z.cloudfront.net"}
            />
        </MbmProvider>
    );
};

export default App;
